module.exports = __webpack_public_path__ + "static/livereload-5755c9f809c70e4986002b9504a6045f.png";